import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectOnlineAgent } from '../../../common/selectors/header';
import { TLocalesKeys } from '../../../types';
import { renderModel } from '../../../util/renderModel';

type TitleContainerProps = {
  expanded: boolean;
};

const wixBrand = renderModel.getWixBrand();

const editorxBot = wixBrand === 'editorx';

export const TitleContainer: FC<TitleContainerProps> = ({ expanded }) => {
  const { t } = useTranslation();
  const agent = useSelector(selectOnlineAgent);

  const titleText = useMemo(() => {
    if (agent) {
      return agent.fullName;
    }
    if (editorxBot) {
      return 'EdiX-Bot';
    }

    return expanded
      ? t<TLocalesKeys>('chatbot-toggle-expanded-title')
      : t<TLocalesKeys>('chatbot-toggle-collapsed-title');
  }, [agent, expanded, t]);

  const subTitleText = useMemo(() => {
    if (agent) {
      return expanded
        ? t<TLocalesKeys>('chatbot-toggle-expanded-agent-sub-title')
        : t<TLocalesKeys>('chatbot-toggle-collapsed-agent-sub-title');
    }

    return expanded
      ? t<TLocalesKeys>('chatbot-toggle-expanded-sub-title')
      : t<TLocalesKeys>('chatbot-toggle-collapsed-sub-title');
  }, [agent, expanded, t]);

  return (
    <>
      <Text
        size="small"
        textAlign="start"
        weight={expanded || agent ? 'bold' : 'thin'}
        dataHook="chatbot-toggle__title"
      >
        {titleText}
      </Text>
      <Text size={expanded ? 'tiny' : 'small'} textAlign="start">
        {subTitleText}
      </Text>
    </>
  );
};
